import React, {Component} from "react"
import {cancel_premium_order, get_premium_history, new_payment} from "../actions/premium";
import LinearProgress from "@mui/material/LinearProgress";
import {
    Box,
    Button,
    Chip,
    Modal,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import Paper from "@mui/material/Paper";
import {daysBetween, formatDateTime} from "../utilities/date";
import CloseIcon from '@mui/icons-material/Close';
import PaymentIcon from '@mui/icons-material/Payment';
import Typography from "@mui/material/Typography";
import PaymentHistoryDialog from "./Dialogs/PaymentHistoryDialog";
import WarningIcon from '@mui/icons-material/Warning';
import HistoryIcon from '@mui/icons-material/History';
import IconButton from "@mui/material/IconButton";
import MuiAlert from '@mui/lab/Alert';
import CheckIcon from '@mui/icons-material/Check';
import {ShoppingCart} from "@mui/icons-material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import {get_user_info} from "../actions/auth";
import GetAppIcon from "@mui/icons-material/GetApp";
import {withRouter} from "react-router-dom";
import withStyles from "@mui/styles/withStyles";
import {connect} from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

const styles = {
    root: {
        padding: 15,
        minHeight: "calc(100vh - 101px)",
    },
    paper: {
        margin: 15
    },
    paperStatus: {
        margin: 15,
        padding: 15
    },
    button: {
        margin: 5
    },
    sectionHeader: {
        padding: 15
    },
    snackbarClose: {
        marginLeft: 15
    },
    primary: {
        color: "#00ff00",
        fontWeight: "bold"
    },
    secondary: {
        color: "#f50057",
        fontWeight: "bold"
    },
    last_row: {
        border: 0
    },
    no_vat: {
        color: "#f50057",
        paddingTop: 10
    },
    table_row: {
        height: 50
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -8,
        marginLeft: -8,
    },
    buttonProgressContainer: {
        position: 'relative'
    },
};

class Premium extends Component {

    constructor(props) {
        super(props);
        this.state = {
            payment_dialog: {
                open: false,
                payments: null
            },
            error: {
                open: false,
                message: ""
            },
            trustpay_dialog: {
                open: false,
                iframe_url: null
            },
            new_pay_clicked: false
        }
    }

    componentDidMount() {
        this.props.get_premium_history();
        this.props.get_user_info();
        if (window.addEventListener) {
            window.addEventListener("message", this.onTrustpayMessage.bind(this), false);
        } else if (window.attachEvent) {
            window.attachEvent("onmessage", this.onTrustpayMessage.bind(this), false);
        }
    }

    cancelPremiumOrder(premium_id) {
        this.setState({
            ...this.state,
            cancel_order_clicked: true
        });
        this.props.cancel_premium_order(premium_id).then((res) => {
            this.props.get_premium_history();
        }).catch(err => {
            this.setState({
                ...this.state,
                error: {
                    open: true,
                    message: err.response.error
                },
                cancel_order_clicked: false
            });
        });
    }

    showPaymentsDialog(payments) {
        this.setState({
            ...this.state,
            payment_dialog: {
                open: true,
                payments: payments
            }
        });
    }

    closePaymentsDialog() {
        this.setState({
            ...this.state,
            payment_dialog: {
                open: false,
                payments: null
            }
        });
    }

    createPayment(premium_id) {
        this.setState({
            ...this.state,
            new_pay_clicked: true
        });
        this.props.new_payment(premium_id).then((res) => {
            this.setState({
                ...this.state,
                trustpay_dialog: {
                    open: true,
                    iframe_url: res.data.iframe_url
                },
                new_pay_clicked: false
            });
        }).catch(err => {
            this.setState({
                ...this.state,
                error: {
                    open: true,
                    message: err.response.error
                },
                new_pay_clicked: false
            });
        });
    }

    closeTrustpayDialog() {
        this.setState({
            ...this.state,
            trustpay_dialog: {
                open: false,
                iframe_url: null
            }
        });
    }

    onTrustpayMessage(message) {
        if (message.origin === "https://amapi.trustpay.eu") { // lepsie by bolo contains trustpay.eu ale neefektivnejsie
            if (message.data.func === "closePopup") {
                this.closeTrustpayDialog();
            }
        }
    }

    handleErrorClose() {
        this.setState({
            ...this.state,
            error: {
                open: false,
                message: ""
            }
        });
    }

    render() {
        const {classes} = this.props;
        if (this.props.premium.history === null || (this.props.auth.user.premium && this.props.premium.current === null)) {
            return <LinearProgress/>
        }
        let pending_order = false;
        this.props.premium.history.map((premium) => {
            if (premium.order_status === "CREATED") {
                pending_order = true;
                return false;
            }
        });
        const buy_table = (
            <>

                <TableContainer component={Paper}
                                style={{background: this.props.theming.darkMode ? "black" : "white"}}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell align="center" style={{
                                    fontSize: "1.25rem",
                                    fontWeight: "bold"
                                }}>Free</TableCell>
                                <TableCell align="center" style={{
                                    fontSize: "1.25rem",
                                    fontWeight: "bold"
                                }}>Great Premium</TableCell>
                                <TableCell align="center" style={{
                                    fontSize: "1.25rem",
                                    fontWeight: "bold"
                                }}>Lite Premium</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow className={classes.table_row}>
                                <TableCell>A. I. Teacher - text</TableCell>
                                <TableCell align="center" className={classes.secondary}>Limited</TableCell>
                                <TableCell align="center" className={classes.primary}>Great Pack</TableCell>
                                <TableCell align="center" className={classes.secondary}>Lite Pack</TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>A. I. Teacher - voice</TableCell>
                                <TableCell align="center" className={classes.secondary}>Limited</TableCell>
                                <TableCell align="center" className={classes.primary}>Great Pack</TableCell>
                                <TableCell align="center" className={classes.secondary}>Lite Pack</TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Clusters</TableCell>
                                <TableCell align="center" className={classes.secondary}>Limited</TableCell>
                                <TableCell align="center" className={classes.primary}>No Limit</TableCell>
                                <TableCell align="center" className={classes.primary}>No Limit</TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Rows per Cluster</TableCell>
                                <TableCell align="center" className={classes.secondary}>Limited</TableCell>
                                <TableCell align="center" className={classes.primary}>No Limit</TableCell>
                                <TableCell align="center" className={classes.primary}>No Limit</TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Cells</TableCell>
                                <TableCell align="center" className={classes.secondary}>Limited</TableCell>
                                <TableCell align="center" className={classes.primary}>No Limit</TableCell>
                                <TableCell align="center" className={classes.primary}>No Limit</TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Sharing of Clusters</TableCell>
                                <TableCell align="center"><CloseIcon color="secondary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Google Translate Feature</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>

                            <TableRow className={classes.table_row}>
                                <TableCell>Terminology - Creating &amp; Editing</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Terminology - Importing &amp; Exporting</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Terminology - Learning &amp; Practice</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Memorizing Last Mistakes Only</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Function - Click on Correct Answer</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Function - Random Learning</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Function - Time-Limit Learning</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Function - Capital Letters Recognition</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Function - Number of Letters Recognition</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow className={classes.table_row}>
                                <TableCell>Evaluation with Overall Learning Ratio</TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                                <TableCell align="center"><CheckIcon color="primary"/></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.last_row}/>
                                <TableCell align="center" className={classes.last_row} style={{
                                    fontSize: "1.25rem",
                                    fontWeight: "bold"
                                }}>Current Plan</TableCell>
                                <TableCell align="center" className={classes.last_row}>
                                    <span className={classes.primary}
                                          style={{
                                              fontSize: "1.25rem",
                                              fontWeight: "bold"
                                          }}>Euro / Year</span><br/>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        className={classes.button}
                                        startIcon={<ShoppingCart/>}
                                        onClick={() => this.props.history.push("/premium/buy/great")}
                                    >
                                        99.95 €
                                    </Button>
                                </TableCell>
                                <TableCell align="center" className={classes.last_row}>
                                    <span className={classes.primary}
                                          style={{
                                              fontSize: "1.25rem",
                                              fontWeight: "bold"
                                          }}>Euro / Year</span><br/>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        className={classes.button}
                                        startIcon={<ShoppingCart/>}
                                        onClick={() => this.props.history.push("/premium/buy/lite")}
                                    >
                                        79.95 €
                                    </Button>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Typography className={classes.no_vat}><sup>*</sup>No VAT registration</Typography>
                <Typography className={classes.no_vat}><sup>*</sup>Payment via Secure Payment Gateway</Typography>
            </>
        );

        return (
            <Box className={classes.root}>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.error.open}
                    autoHideDuration={5000}
                    onClose={this.handleErrorClose.bind(this)}
                >
                    <MuiAlert elevation={6} variant="filled" severity="error">
                        {this.state.error.message}
                        <IconButton className={classes.snackbarClose} size="small" aria-label="close" color="inherit"
                                    onClick={this.handleErrorClose.bind(this)}>
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    </MuiAlert>
                </Snackbar>

                <PaymentHistoryDialog open={this.state.payment_dialog.open}
                                      payments={this.state.payment_dialog.payments}
                                      onClose={this.closePaymentsDialog.bind(this)}/>


                <Modal open={this.state.trustpay_dialog.open} onClose={() => this.closeTrustpayDialog()}>
                    <iframe src={this.state.trustpay_dialog.iframe_url} style={{height: "100%", width: "100%"}}
                            frameBorder="0"/>
                </Modal>
                <Paper className={classes.paperStatus}
                       style={{background: this.props.theming.darkMode ? "black" : "white"}}>
                    {this.props.auth.user.premium ?
                        <>
                            <Typography component="div">
                                Current premium status: <Chip label="Active" color="primary"/>
                            </Typography>
                            <Typography component="div">
                                Active until: {formatDateTime(new Date(this.props.premium.current.end))}
                            </Typography>
                            <Typography component="div">
                                Tier: {this.props.premium.current.tier === "lite" ? "Lite" : "Great"}
                                {this.props.premium.current.tier === "lite"
                                    && <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<ShoppingCart/>}
                                        onClick={() => this.props.history.push("/premium/buy/great")}
                                    >
                                        Upgrade to Great
                                    </Button>}
                            </Typography>
                            <Typography component="div">
                                Days remaining: {daysBetween(new Date(), new Date(this.props.premium.current.end))}
                            </Typography>
                            {this.props.auth.user.text_characters_remaining && <Typography component="div">
                                A. I. Teacher - text - input & output characters
                                remaining: {this.props.auth.user.text_characters_remaining}
                            </Typography>}
                            {this.props.auth.user.voice_characters_remaining && <Typography component="div">
                                A. I. Teacher - voice - input & output characters
                                remaining: {this.props.auth.user.voice_characters_remaining}
                            </Typography>}
                            {/*{this.props.premium.current.days === 30 &&*/}
                            {/*    this.props.premium.history.filter((premium) =>*/}
                            {/*        (new Date(premium.start)).getTime() > (new Date()).getTime() && premium.order_status === "PAID"*/}
                            {/*    ).length === 0*/}
                            {/*    && <Button*/}
                            {/*        variant="contained"*/}
                            {/*        color="primary"*/}
                            {/*        size="large"*/}
                            {/*        className={classes.button}*/}
                            {/*        startIcon={<ShoppingCart/>}*/}
                            {/*        onClick={() => this.props.history.push("/premium/buy/year")}*/}
                            {/*    >*/}
                            {/*        Upgrade to one year*/}
                            {/*    </Button>}*/}
                            {process.env.NODE_ENV !== 'production' &&
                                <><Button
                                    color="secondary"
                                    variant="contained"
                                    startIcon={<DeleteIcon/>} onClick={() => {
                                    axios
                                        .get(
                                            "/api/expire-current-premium"
                                        ).then(res => {
                                        location.reload();
                                    });
                                }}>[DEMO] Expirovať aktuálne prémium</Button>
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        style={{marginLeft: 15}}
                                        onClick={() => {
                                            axios
                                                .get(
                                                    "/api/set-premium-end-to-3-days-after-now"
                                                ).then(res => {
                                                location.reload();
                                            });
                                        }}>[DEMO] Nastaviť expiráciu na 3 dni</Button></>}
                        </>
                        :
                        (pending_order ?
                                <>
                                    Current premium status: <Chip
                                    label="Waiting for payment"
                                />
                                </>
                                :
                                buy_table
                        )}
                </Paper>
                <Paper className={classes.paper} style={{background: this.props.theming.darkMode ? "black" : "white"}}>
                    <Typography variant="h5" component="h5"
                                className={classes.sectionHeader}>
                        Premium history
                    </Typography>
                    <TableContainer component={Paper}
                                    style={{background: this.props.theming.darkMode ? "black" : "white"}}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Start</TableCell>
                                    <TableCell>End</TableCell>
                                    {/*<TableCell>Duration</TableCell>*/}
                                    <TableCell>Tier</TableCell>
                                    <TableCell>Order status</TableCell>
                                    <TableCell>Active status</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.props.premium.history.map((premium) => {
                                    let status = <Chip
                                        label="Waiting for payment"
                                    />;

                                    let active_payments = 0;
                                    const active_states = [
                                        //"CREATED",
                                        "PAYMENT_METHOD_CHOSEN", "AUTHORIZED", "UNTRUSTED_PAID"];
                                    premium.payments.map((payment) => {
                                        if (active_states.includes(payment.current_state)) {
                                            active_payments++;
                                        }
                                    });
                                    let pay_button = false;
                                    if (premium.order_status === "PAID") {
                                        status = <Chip
                                            label="Paid"
                                            color="primary"
                                        />;
                                    } else if (premium.order_status === "CANCELED") {
                                        status = <Chip
                                            label="Cancelled"
                                            color="secondary"
                                        />;
                                    } else {

                                        if (active_payments === 0) {
                                            status = <Chip
                                                label="No pending payment"
                                                color="secondary"
                                                icon={<WarningIcon/>}
                                            />;
                                            pay_button = true;
                                        }
                                    }

                                        return <TableRow key={premium.id}>
                                            <TableCell>{premium.start ? formatDateTime(new Date(premium.start)) : "Date will appear after payment"}</TableCell>
                                            <TableCell>{premium.end ? formatDateTime(new Date(premium.end)) : "Date will appear after payment"}</TableCell>
                                            {/*<TableCell>{premium.days} days</TableCell>*/}
                                            <TableCell>{premium.tier === "lite" ? "Lite" : "Great"}</TableCell>
                                            <TableCell>{status}</TableCell>
                                            <TableCell>
                                                {premium.active ?
                                                    <Chip
                                                        label="Active"
                                                        color="primary"
                                                    />
                                                    :
                                                    ((new Date(premium.start)).getTime() > (new Date()).getTime() ?
                                                        <Chip
                                                            color="secondary"
                                                            label="Future"
                                                        />
                                                        :
                                                        <Chip
                                                            label="Inactive"
                                                        />)
                                                }
                                            </TableCell>
                                            <TableCell>
                                                {premium.download !== null && <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    className={classes.button}
                                                    startIcon={<GetAppIcon/>}
                                                    href={premium.download}
                                                    target={"_blank"}
                                                >
                                                    PDF
                                                </Button>}
                                                {pay_button && <span className={classes.buttonProgressContainer}><Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    className={classes.button}
                                                    disabled={this.state.new_pay_clicked}
                                                    startIcon={<PaymentIcon/>}
                                                    onClick={() => this.createPayment(premium.id)}
                                                >
                                                    New payment
                                                </Button>{this.state.new_pay_clicked &&
                                                    <CircularProgress size={16}
                                                                      className={classes.buttonProgress}/>}</span>}
                                                {premium.payments.length > 0 &&
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        className={classes.button}
                                                        startIcon={<HistoryIcon/>}
                                                        onClick={() => this.showPaymentsDialog(premium.payments)}
                                                    >
                                                        View payment history
                                                    </Button>
                                                }
                                                {premium.order_status === "CREATED" && premium.payments.length > 0 && premium.payments[0].current_state !== "UNTRUSTED_PAID" &&
                                                    <span className={classes.buttonProgressContainer}><Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        disabled={this.state.cancel_order_clicked}
                                                        className={classes.button}
                                                        startIcon={<CloseIcon/>}
                                                        onClick={() => this.cancelPremiumOrder(premium.id)}
                                                    >
                                                    Cancel premium order
                                                </Button>{this.state.cancel_order_clicked &&
                                                        <CircularProgress size={16}
                                                                          className={classes.buttonProgress}/>}</span>}
                                            </TableCell>
                                        </TableRow>
                                    }
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>)
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    premium: state.premium,
    theming: state.theming,
    is_logged: state.auth.is_logged
});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {get_premium_history, new_payment, cancel_premium_order, get_user_info}
)(Premium)));
